import { render, staticRenderFns } from "./DashboardProjectItem.vue?vue&type=template&id=23805b18&scoped=true&"
import script from "./DashboardProjectItem.vue?vue&type=script&lang=ts&"
export * from "./DashboardProjectItem.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardProjectItem.vue?vue&type=style&index=0&id=23805b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23805b18",
  null
  
)

export default component.exports